import React from 'react';
import './ui.css';

export function YInput({ id, type = 'text', value, onChange, onKeyDown, placeholder, disabled = false, invalid = false, className = '', min, max, step, rows, ...rest }) {
  const Tag = type === 'textarea' ? 'textarea' : 'input';
  const inputProps = {
    id,
    className: `y-input ${invalid ? 'is-invalid' : ''} ${className}`.trim(),
    value,
    onChange,
    onKeyDown,
    placeholder,
    disabled,
    ...rest,
  };
  if (Tag === 'input') {
    inputProps.type = type;
    if (min !== undefined) inputProps.min = min;
    if (max !== undefined) inputProps.max = max;
    if (step !== undefined) inputProps.step = step;
  } else {
    if (rows !== undefined) inputProps.rows = rows;
  }
  return <Tag {...inputProps} />;
}
